import type { AnyRecord } from "../types";
import { parseJsonObject } from "../utilities/objectHelper";

export async function* parseSseStream<T extends AnyRecord>(stream: ReadableStream): AsyncGenerator<T> {
  const reader = stream.pipeThrough(new TextDecoderStream()).getReader();
  let buffer = "";

  while (true) {
    const { done, value } = await reader.read();
    if (done) {
      break;
    }
    buffer += value;
    const lines = buffer.split("\n");
    buffer = lines.pop() ?? "";
    for (const line of lines) {
      if (line.startsWith("data: ")) {
        const json = line.slice(6).trim();
        if (json) {
          const event = parseJsonObject<T>(json);
          if (event) {
            yield event;
          }
        }
      }
    }
  }
}
